import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './styles/index.css'

export default class LoadingIconButton extends Component {

    render() {
        return (
            <button
                onClick={this.props.onClick}
                className={this.props.loading
                    ? `spark-btn spark-btn--icon ${this.props.icon} icon-loader spark-progress`
                    : `spark-btn--icon spark-icon ${this.props.icon}`}
                disabled={this.props.disabled || this.props.loading}
                title={this.props.title}>
                <span className="spark-progress__meter"/>
            </button>
        )
    }
}

LoadingIconButton.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/shared/components/LoadingIconButton/index.js